import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

import { GroupClassDetailsModel, GroupClassWaitListModel } from '@bayclubs/group-classes-employee-api';
import { Subscription } from 'rxjs';
import { GroupClassesApiService } from '../../../../shared/shared.module';
import { BookingEventService } from '../../../services/booking.service';

@Component({
    selector: 'app-group-classes-details-wait-list',
    templateUrl: './group-classes-details-wait-list.component.html',
    styleUrls: ['./group-classes-details-wait-list.component.scss'],
    standalone: false
})
export class GroupClassesDetailsWaitListComponent implements OnInit, OnDestroy, OnChanges {
    @Input()
    public model: GroupClassDetailsModel;

    waitListModel: GroupClassWaitListModel;

    subscriptions: Subscription;

    constructor(private api: GroupClassesApiService, private bookingService: BookingEventService) {
        this.subscriptions = new Subscription();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['model'] && !!this.model) {
            this.loadWaitList();
        }
    }

    ngOnInit() {
        this.loadWaitList();
        this.subscriptions.add(
            this.bookingService.bookingCancelled$.subscribe(data => {
                this.loadWaitList();
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    private loadWaitList() {
        this.api.getWaitList(this.model.id).subscribe(data => (this.waitListModel = data));
    }
}
